import React from 'react';
import { Box, Button, Dropdown, Select, Image, Alert, Typography, Grid, TextField, Calendar } from '@iho-design-system/Loader';
import moment from 'jalali-moment';



import CalendarSVG from '../../assets/images/icons/calendar.svg';
import profileImg from '../../assets/images/icons/user-profile.svg';
import iconDownSVG from '../../assets/images/icons/chevron-down.svg';
import getAPI from './../../api/get';
import AgencyProfile from '../../api/edit/AgencyProfile';


export default function BossInfo() {
    const [BirthDateInfo, setBirthDateInfo] = React.useState('');
    const [Errs, setErrs] = React.useState(['']);
    const [Success, setSuccess] = React.useState(false);
    const [DataCeoInfo, setDataCeoInfo] = React.useState({
        BirthDate: "",
        Email: '',
        FirstName: '',
        Gender: '0',
        LastName: "",
        Mobile: "",
        Confirmed: false,

    })
    const typeUser = localStorage.getItem('userType');

    /*
       - alert
   */
    const [alert, setAlert] = React.useState('');
    const [alertColor, setAlertColor] = React.useState('success');
    const [alertStatus, setAlertStatus] = React.useState('d-none');
    const alertProps = (config) => {
        setAlert(config[1])
        setAlertColor(config[0]);
        setAlertStatus('d-flex');
        setTimeout(() => {
            setAlertStatus('d-none');
        }, 3000);
    }
    /*
           - toggleCaldendar
       */
    const toggleCalendar = (event, calendar) => {
        if (event.target.tagName === 'INPUT' && calendar === 'BirthDate') {
            setBirthDateInfo('');
        }


        if (event.target.tagName === 'DIV' || event.target.tagName === 'INPUT') {
            document.querySelector(`.${calendar}`).classList.toggle('d-none');
        }
    }

    React.useEffect(() => {
        const fetchData = async () => {



            let userTypeParameters = {
                ctrl: 'AgencyProfile',
                method: 'GetCeoInfo',
                query: ''
            }







            let response = await getAPI(userTypeParameters);
            if (response.status == 200) {
                setDataCeoInfo({ //response.data
                    ...response.data
                });
                if (response.data?.BirthDate){
                    setBirthDateInfo(moment(response.data?.BirthDate?.split('T'), 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD'));
                }

            }


        }
        fetchData();
    }, []);

    /*
         - editUserProfileHandler
     */
    const editCeoInfo = (key, value) => {


        switch (key) {
            case 'BirthDate':
                setBirthDateInfo(value);
                setDataCeoInfo((prevState) => ({
                    ...prevState,
                    BirthDate: moment.from(value, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
                }))
                break;
            case 'Email':
                setDataCeoInfo({
                    ...DataCeoInfo,
                    Email: value
                })
                break;
            case 'FirstName':
                setDataCeoInfo({
                    ...DataCeoInfo,
                    FirstName: value
                })
                break;
            case 'LastName':
                setDataCeoInfo({
                    ...DataCeoInfo,
                    LastName: value
                })
                break;
            case 'Gender':
                setDataCeoInfo({
                    ...DataCeoInfo,
                    Gender: value
                })
                break;
            case 'Mobile':
                setDataCeoInfo({
                    ...DataCeoInfo,
                    Mobile: value
                })
                break;





            default:
                break;
        }


    }


    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrs(['']); // Clear previous errors
        let allErrors = []; // Array to collect error messages
        let isSend = true;

        // Define validation rules
        const validationRules = [
            { field: "FirstName", message: "نام نباید خالی باشد" },
            { field: "LastName", message: "نام خانوادگی نباید خالی باشد" },
            { field: "Gender", message: "جنسیت نباید خالی باشد", isZero: true },
            { field: "Mobile", message: "تلفن همراه نباید خالی باشد" },
            {
                field: "Mobile",
                message: "از اعداد برای تلفن همراه استفاده کنید",
                isRegex: true,
                regex: /^[\u06F0-\u06F90-9]+$/,
            },
        ];

        // Validate fields based on rules
        validationRules.forEach((rule) => {
            const value = DataCeoInfo[rule.field];

            if (rule.isRegex && (!value || !rule.regex.test(value))) {
                // If regex validation fails
                allErrors.push(rule.message);
                isSend = false;
            } else if (rule.isZero && (!value || value === "0")) {
                // If the value is empty or "0" for dropdowns
                allErrors.push(rule.message);
                isSend = false;
            } else if (!rule.isRegex && !value) {
                // If the field is empty
                allErrors.push(rule.message);
                isSend = false;
            }
        });

        // Handle errors
        if (!isSend) {
            allErrors.forEach((err) => {
                setErrs((prevErrors) => [...prevErrors, err]); // Update error state
                alertProps(["danger", err]); // Display error message
            });
            return; // Stop further execution
        }

        // Proceed with API call if validation passes
        let method = "SaveCeoInfo";
        let result = await AgencyProfile(method, DataCeoInfo);
        window.scrollTo(0, 0);

        if (result.status === "success") {
            alertProps(["success", "با موفقیت ثبت شد"]);
            setSuccess(true);
        } else {
            setSuccess(false);
            if (Array.isArray(result.data.errors)) {
                result.data.errors.forEach((item) => {
                    setErrs((prevErrors) => [...prevErrors, item]);
                    alertProps(["danger", item]);
                });
            } else {
                alertProps(["danger", result.data.Message || "خطای ناشناخته رخ داده است"]);
            }
        }
    };

    const resetForm = () => {
        setDataCeoInfo({
            BirthDate: "",
            Email: '',
            FirstName: '',
            Gender: '0',
            LastName: "",
            Mobile: "",
            Confirmed: false,
        });
        setBirthDateInfo('');
        setErrs(['']);

    }

    return (
        <React.Fragment>
            <form onSubmit={handleSubmit}
                method="POST"  >
                <Box
                    className={`bg-white rounded-lg border-solid border-light p-xl`}>

                    <Grid>
                        <Grid.Wrapper>
                            <Grid.Item
                                size='col-8'>
                                <Grid.Wrapper>
                                    <Grid.Item
                                        className={`border-solid-bottom border-light`}
                                        size='col-12'>
                                        <Typography ms={{
                                            fontWeight: 'bold'
                                        }}>
                                            اطلاعات تماس مدیرعامل
                                        </Typography>
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-6'>
                                        <TextField
                                            onChange={(event) => editCeoInfo('FirstName', event)}

                                            value={DataCeoInfo.FirstName ? DataCeoInfo.FirstName : ''}
                                            label='  نام '

                                        />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-6'>

                                        <TextField
                                            value={DataCeoInfo.LastName ? DataCeoInfo.LastName : ''}
                                            label=' نام خانوادگی'

                                            onChange={(event) => editCeoInfo('LastName', event)}

                                        />

                                    </Grid.Item>
                                    <Grid.Item
                                        className={`position-relative`}
                                        size='col-6'>
                                        <Box
                                            onClick={(event) => toggleCalendar(event, 'BirthDate')}>
                                            <TextField
                                                label='تاریخ تولد (اختیاری)'
                                                onChange={(event) => editCeoInfo('BirthDate', event)}
                                                icon={CalendarSVG}
                                                // value={(getDataBaseB2B.RegisterDate) ? moment(getDataBaseB2B.RegisterDate.split('T')[0], 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD') : advancedSearchInsertDate} 
                                                value={BirthDateInfo ? BirthDateInfo : ''}
                                            />

                                            <Box
                                                className={`BirthDate d-none position-absolute`}
                                                ms={{
                                                    width: '320px',
                                                    top: 'calc(75px + var(--sizing-xs))',
                                                    zIndex: '1'
                                                }}>
                                                <Calendar
                                                    onChange={(event) => editCeoInfo('BirthDate', event)} />
                                            </Box>
                                        </Box>
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-6'>
                                        <Select
                                            onChange={(event) => editCeoInfo('Gender', event)}

                                            label='جنسیت'

                                            init={DataCeoInfo.Gender ? DataCeoInfo.Gender : 0}
                                        >
                                            <Select.Item

                                                value={0}>
                                                انتخاب کنید
                                            </Select.Item>
                                            <Select.Item

                                                value={1}>
                                                مرد
                                            </Select.Item>
                                            <Select.Item

                                                value={2}>
                                                زن
                                            </Select.Item>

                                        </Select>
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-6'>
                                        <TextField

                                            onChange={(event) => editCeoInfo('Mobile', event)}

                                            value={DataCeoInfo.Mobile ? DataCeoInfo.Mobile : ''}
                                            label='  تلفن همراه '

                                        />
                                    </Grid.Item>



                                    <Grid.Item
                                        size='col-6'>
                                        <TextField
                                            onChange={(event) => editCeoInfo('Email', event)}
                                            type="email"

                                            value={DataCeoInfo.Email ? DataCeoInfo.Email : ''}
                                            label='  ایمیل (اختیاری) '

                                        />
                                    </Grid.Item>
                                    <Grid.Item
                                size='col-12'>
                                <Button
                                    ms={{
                                        padding: '8px 20px'
                                    }}
                                    type="submit"
                                    className={``}
                                    variant='filled'
                                    color='primary'>
                                    ذخیره اطلاعات
                                </Button>
                                <Button
                                    ms={{
                                        padding: '8px 20px'
                                    }}
                                    onClick={() => resetForm()}
                                    className={`mx-md`}
                                    variant='outlined'
                                    color='primary'>
                                    انصراف
                                </Button>
                            </Grid.Item>
                                </Grid.Wrapper>
                            </Grid.Item>
                            <Grid.Item
                                size='col-4'>
                                <Image
                                    src={profileImg}
                                    ms={{
                                        background: '#F5F5F7',
                                        borderRadius: '16px'

                                    }}
                                />
                            </Grid.Item>
                            
                        </Grid.Wrapper>

                    </Grid>

                </Box>

            </form>
            <>

                {(!Success && Errs) && Errs.map((err, index) => (
                    <Alert key={index} className={`alert ${alertStatus}`}
                        color={alertColor}
                        ms={{
                            bottom: index == 0 ? (index + 1) * 50 + 'px !important' : index * 50 + 'px !important'
                        }}>
                        {err}
                    </Alert>
                ))}

            </>
            {Success && <Alert
                className={`alert ${alertStatus}`}
                color={alertColor}
                ms={{
                    bottom: '75px !important'
                }} >
            {alert}

            </Alert>}

        </React.Fragment>
    )
}
